import React from "react";
import { Button, Tag, Icon, Modal, Select, notification, Divider } from "antd";
import api from "../../../../../../../services/api";

import "./styles.css";

export function StatusHO({ status, idParcela, data }) {
  const [isEditing, setEditing] = React.useState(false);
  const [isSaving, setSaving] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(status);
  const [value, setValue] = React.useState(status);

  const getTagComponent = () => {
    switch (value.toLowerCase()) {
      case "em aberto":
        return <Tag color="blue">EM ABERTO</Tag>;
      case "adiantamento":
        return <Tag color="orange">ADIANTAMENTO</Tag>;
      case "pago":
        return <Tag color="green">PAGO</Tag>;
      default:
        return <Tag color="#787878">{status}</Tag>;
    }
  };

  const TagComponent = getTagComponent();

  const toggleEditing = () => setEditing(!isEditing);
  const STATUS_PARCELA_PAGO = "1";
  const canEdit = data.status_parcela === STATUS_PARCELA_PAGO;

  const handleSave = () => {
    setSaving(true);

    api
      .put(`/acordo/parcela/${idParcela}/`, {
        status_ho_contratual: selectedValue,
        data_vencimento: data.data_vencimento,
        num_parcela: data.num_parcela
      })
      .then(() => {
        toggleEditing();
        // setNumberNF(numeroNF);
        // setConciliado(false);

        notification.success({
          message: "Status HO atualizado com sucesso."
        });

        setValue(selectedValue);
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um erro ao atualizar o status."
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <React.Fragment>
      <div className="statusho__wrapper">
        {TagComponent}
        {canEdit && (
          <React.Fragment>
            <Divider type="vertical" />
            <Button type="primary" ghost size="small" onClick={toggleEditing}>
              <Icon type="edit" />
            </Button>
          </React.Fragment>
        )}
      </div>
      <Modal
        visible={isEditing}
        title="Alterar status HO"
        okText="Salvar"
        cancelText="Cancelar"
        onCancel={toggleEditing}
        confirmLoading={isSaving}
        onOk={handleSave}
        cancelButtonProps={{
          disabled: isSaving
        }}
      >
        <div>
          <label for="value">Selecione o status:</label>
          <div style={{ marginTop: "5px" }}>
            {isEditing && (
              <Select
                style={{ width: "100%" }}
                defaultValue={value}
                onChange={value => setSelectedValue(value)}
              >
                <Select.Option value={"Em Aberto"}>Em aberto</Select.Option>
                <Select.Option value={"Adiantamento"}>
                  Adiantamento
                </Select.Option>
                <Select.Option value={"Pago"}>Pago</Select.Option>
                <Select.Option value={"Nao Pago"}>Nao Pago</Select.Option>
                <Select.Option value={"Pago Parcial"}>Pago Parcial</Select.Option>
              </Select>
            )}
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoParcelas/Parcela/StatusHO/index.jsx